import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/data';

export default function TopBar() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, Atak Sistem Enerji web siteniz üzerinden ulaşıyorum. Bilgi almak istiyorum.')}`;

  return (
    <div className="hidden md:block bg-secondary-800 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-9 text-xs">
        <span className="flex items-center gap-1.5">
          <i className="ri-map-pin-2-line text-primary-400 w-3.5 h-3.5 flex items-center justify-center"></i>
          {siteConfig.serviceArea}
        </span>
        <div className="flex items-center gap-5">
          <a href={`tel:${siteConfig.phoneRaw}`} className="flex items-center gap-1.5 hover:text-primary-400 transition-colors whitespace-nowrap">
            <i className="ri-phone-line text-primary-400 w-3.5 h-3.5 flex items-center justify-center"></i>
            {siteConfig.phone}
          </a>
          <span className="text-background-50/20">|</span>
          <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 hover:text-primary-400 transition-colors whitespace-nowrap">
            <i className="ri-whatsapp-line text-primary-400 w-3.5 h-3.5 flex items-center justify-center"></i>
            WhatsApp'tan Bilgi Al
          </a>
        </div>
      </div>
    </div>
  );
}